import { ActionTypes } from "../../constants/ActionTypes";
import { ISignatureReducer } from "../../interfaces";

const INIT_STATE: ISignatureReducer = {
  signaturetList: [],
  searchText: "",
  canSignLetter: false,
  canConfirmLetter: false,
  isLock: false,
  isUnLock: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.CHECK_CAN_SIGN_LETTER: {
      return {
        ...state,
        canSignLetter: false,
      };
    }

    case ActionTypes.CHECK_CAN_CONFIRM_LETTER: {
      return {
        ...state,
        canConfirmLetter: false,
      };
    }

    case ActionTypes.SIGN_LETTER_SUCCESS: {
      return {
        ...state,
        isLock: true,
        isUnLock: false,
      };
    }

    case ActionTypes.RETRIVE_LETTER_SUCCESS: {
      return {
        ...state,
        isUnLock: true,
        isLock: false,
      };
    }

    case ActionTypes.ClearSignatureState: {
      return {
        ...state,
        isUnLock: false,
        isLock: false,
      };
    }

    case ActionTypes.CHECK_CAN_SIGN_LETTER_SUCCESS: {
      return {
        ...state,
        canSignLetter: action.payload,
      };
    }

    case ActionTypes.CHECK_CAN_CONFIRM_LETTER_SUCCESS: {
      return {
        ...state,
        canConfirmLetter: action.payload,
      };
    }

    case ActionTypes.GET_SIGNATURE_LIST: {
      return {
        ...state,
        searchText: action.payload,
      };
    }

    case ActionTypes.FETCH_SIGNATURE_LIST_SUCCESS: {
      return {
        ...state,
        signaturetList: action.payload,
      };
    }

    case ActionTypes.CONFIRM_LETTER: {
      return {
        ...state,
      };
    }

    case ActionTypes.CONFIRM_LETTER_SUCCESS: {
      return {
        ...state,
      };
    }

    case ActionTypes.REMOVE_CONFIRM_LETTER: {
      return {
        ...state,
      };
    }

    case ActionTypes.REMOVE_CONFIRM_LETTER_SUCCESS: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};
